import { createSelector } from 'reselect';
import CapeUsageMonitoringByUserColumns
  from '../../containers/CapeUsageMonitoringByUserColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000.isLoading;

export const getData =
  ReportsDefinition.CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000.getDataFunction();

export const getColumns =
  createSelector(getData, CapeUsageMonitoringByUserColumns);
